import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";
import apiHelper from "../../../util/ApiHelper";

const useStyles = makeStyles((theme) => ({
  innerBox: {
    background: "#ffffff",
    marginBottom: theme.spacing(4),
    "& *": {
      fontSize: "13px",
      lineHeight: "15px",
    },
  },
  sectionBox: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: "300",
    fontSize: "13px",
    lineHeight: "15px",
    color: "#333333",
  },
  itemMetaTitle: {
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#333333",
    paddingLeft: "10px",
  },
  itemTitle: {
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#333333",
  },
  itemValue: {
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#333333",
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  buttonGroup: {
    textAlign: "right",
    marginTop: "-20px",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
}));

const defaultFormValues = {
  referenceNum: "",
  titleEn: "",
  titleTc: "",
  yearOfPremiere: "",
  productionCountry: "",
  hasFilm: "",
  filmLinks: "",
  hasAwards: "",
  showStatus: "",
  prodDistribution: {
    1: {
      name: "",
      telephone: "",
      fax: "",
      email: "",
      address: "",
    },
    2: {
      name: "",
      telephone: "",
      fax: "",
      email: "",
      address: "",
    },
    3: {
      name: "",
      telephone: "",
      fax: "",
      email: "",
      address: "",
    },
  },
  directorProTeam: {
    director: "",
    directorEmail: "",
    producer: "",
    scriptwriter: "",
    originalAuthor: "",
    cinematographer: "",
    artDirector: "",
    editor: "",
    music: "",
    sound: "",
    visualEffect: "",
  },
  mainCast: {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
  },
  duration: 0,
  screenFormat: 0,
  formatInfo: {
    length: "",
    noOfReels: "",
    subtitle: "",
    resolution: "",
    resolutionOthers: "",
    format: "",
    encryption: "",
    frameRate: "",
    frameRateOthers: "",
    aspectRatio: "",
    aspectRatioOthers: "",
    soundFormat: "",
    soundFormatOther: "",
  },
  printTraffic: {
    1: {
      type: "",
      typeOthers: "",
      name: "",
      address: "",
      telephone: "",
      fax: "",
      email: "",
    },
    2: {
      type: "",
      typeOthers: "",
      name: "",
      address: "",
      telephone: "",
      fax: "",
      email: "",
    },
  },
  proCompanyName: "",
  proPersonName: "",
  proAddress: "",
  proTel: "",
  proFax: "",
  proEmail: "",
};

function InvitedEntryDetailPage(props) {
  const history = useHistory();
  const classes = useStyles();
  const { match, location } = props;
  const { id } = match.params;
  const [defaultValue, setDefaultValue] = React.useState(defaultFormValues);
  console.log("location", location);
  const page = (location.state && location.state.page) || 0;
  const rowsPerPage = (location.state && location.state.rowsPerPage) || 10;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const getApplicationDetail = React.useCallback(async () => {
    try {
      const result = await apiHelper.hkiff.getInvitedEntryById(id);
      console.log("default values:", result.data);
      setDefaultValue(result.data);
    } catch (err) {
      console.log(err);
    }
  }, [id]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(() => {
    getApplicationDetail();
  }, [getApplicationDetail]);

  console.log(defaultValue);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Entry Management > Invited Entry Detail
      </Typography>
      <Box className={classes.innerBox}>
        <Box className={classes.sectionBox}>
          <Grid container xs={12} direction="row">
            <Grid item xs={6}>
              <strong>Reference no. #{defaultValue.referenceNum || "-"}</strong>
            </Grid>
            <Grid item xs={6}>
              <Box
                width="100%"
                component="span"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <strong>Submission Time &nbsp; </strong>{" "}
                {defaultValue.submissionTime || "-"}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* ENTRY Detail */}
        <Box className={classes.sectionBox}>
          <Grid container xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Invited Entry Details
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Original Title
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.titleTc || "-"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      English Title
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.titleEn || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Original Language
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.originalLanguage || "-"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Subtitle
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.subtitle || "-"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Year of Premiere
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.yearOfPremiere || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Country of Origin
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.productionCountry || "-"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Festival at which the film has already participated
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      <div dangerouslySetInnerHTML={{__html: defaultValue.hasFilm || "-"}}></div>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Film official website
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.filmLinks || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Prize(s) won at these festivals
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      <div dangerouslySetInnerHTML={{__html: defaultValue.hasAwards || "-"}}></div>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Premiere status when the film is screened at HKIFF
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.showStatus || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* PRODUCTION COMPANY */}
        <Box className={classes.sectionBox}>
          <Grid container xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Production company
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Name</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[1].name || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Telephone
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[1].telephone || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Fax</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[1].fax || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Email</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[1].email || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* WORLD SALES AGENT */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                World Sales Agent
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Name</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[2].name || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Telephone
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[2].telephone || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Fax</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[2].fax || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Email</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[2].email || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Address</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[2].address || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* DISTRIBUTION COMPANY DETAILS */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Distribution Company In Hong Kong
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Name</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[3].name || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Telephone
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[3].telephone || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Fax</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[3].fax || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Email</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.prodDistribution[3].email || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* DIRECTOR/PRODUCTION TEAM DETAILS */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Director/Production Team
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Director
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.director) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Director Email
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.directorEmail) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Producer
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.producer) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Scriptwriter
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.scriptwriter) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Original Author
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.originalAuthor) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Cinematographer
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.cinematographer) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Art Director
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.artDirector) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Editor</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.editor) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Music</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.music) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Sound</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.sound) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Visual Effect
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.directorProTeam &&
                      defaultValue.directorProTeam.visualEffect) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* MAIN CAST */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Main Cast
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    1.Names of Actors (Roles)
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.mainCast && defaultValue.mainCast[1]) || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    2.Names of Actors (Roles)
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.mainCast && defaultValue.mainCast[2]) || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    3.Names of Actors (Roles)
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.mainCast && defaultValue.mainCast[3]) || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    4.Names of Actors (Roles)
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.mainCast && defaultValue.mainCast[4]) || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    5.Names of Actors (Roles)
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.mainCast && defaultValue.mainCast[5]) || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* TECHNICAL INFO DETAILS */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Technical Information
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Duration
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.duration || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Color</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.color || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Screen Format
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.screenFormat || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Subtitle
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                      defaultValue.formatInfo.subtitle) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Resolution
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.formatInfo &&
                    defaultValue.formatInfo.resolution &&
                    defaultValue.formatInfo.resolution !== "Others"
                      ? defaultValue.formatInfo.resolution
                      : defaultValue.formatInfo.resolutionOthers || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Format</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                      defaultValue.formatInfo.format) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Encryption
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                      defaultValue.formatInfo.encryption) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Frame Rate
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                    defaultValue.formatInfo.frameRate) || '-'}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Frame Rate Others
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                  {(defaultValue.formatInfo &&
                    defaultValue.formatInfo.frameRateOthers) || '-'}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Aspect Ratio
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                    defaultValue.formatInfo.aspectRatio) || '-'}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Aspect Ratio Others
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                    defaultValue.formatInfo.aspectRatioOthers) || '-'}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Sound</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                  {(defaultValue.formatInfo &&
                    defaultValue.formatInfo.soundFormat) || '-' }
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Sound Others</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                    defaultValue.formatInfo.soundFormatOther) || '-' }
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Scanning</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                    defaultValue.formatInfo.scanning) || '-' }
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Length</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                        defaultValue.formatInfo.length) || '-' }
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>No of Reels</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                        defaultValue.formatInfo.noOfReels) || '-' }
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>System</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                        defaultValue.formatInfo.system) || '-' }
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>No of Tapes</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.formatInfo &&
                        defaultValue.formatInfo.noOfTapes) || '-' }
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* PRINT TRAFFIC */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Print Traffic
              </Typography>
            </Grid>
            <Typography className={classes.itemMetaTitle}>
              Print / Video will be coming from
            </Typography>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[1].type) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[1].typeOthers) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Name</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[1].name) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Telephone
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[1].telephone) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Fax</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[1].fax) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Email</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[1].email) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Typography className={classes.itemMetaTitle}>
              Person to whom print / video should be returned / sent to
            </Typography>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[2].type) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[2].typeOthers) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Address</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[2].address) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Name</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[2].name) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Telephone
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[2].telephone) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Fax</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[2].fax) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Email</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {(defaultValue.printTraffic &&
                      defaultValue.printTraffic[2].email) ||
                      "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* ENTRANT'S AGREEMENT TO FESTIVAL */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Entrant's Agreement to Festival
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Company Name
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.proCompanyName || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Person Name
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.proPersonName || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Address</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.proAddress || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Telephone
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.proTel || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Fax</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.proFax || "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>Email</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.proEmail || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <div className={classes.buttonGroup}>
        <Button
          variant="contained"
          disableElevation
          style={{
            color: "white",
            background: "#306F9D",
            marginRight: "5px",
            padding: "9px 16px",
          }}
          onClick={() => {
            history.push({
              pathname: "/hkiff/invited-entry",
              state: { page: page, rowsPerPage: rowsPerPage },
            });
          }}
        >
          Back to List
        </Button>
      </div>
    </Box>
  );
}

export default InvitedEntryDetailPage;
